<template>
  <aside class="fleet-panel" :class="{ 'is-floating': floating }">
    <div v-if="collapsed && !suppressCollapsedPopovers" class="collapsed-fleet-tools">
      <UiPopover
        v-if="isGod && showShopSelector"
        ref="collapsedShopPopover"
        :popper-options="collapsedPopoverOptions"
        placement="left-start"
        width="276"
        trigger="manual"
        :value="isCollapsedToolActive('shop')"
        :visible-arrow="!isCollapsedToolActive('fleet')"
        transition="ground-station-popover"
        popper-class="ground-station-collapsed-shop-popover"
        @click.native.stop
        @after-enter="scheduleCollapsedPopoverStack"
      >
        <GroundStationShopSelector v-model="selectedShopId" class="collapsed-popover-content" :class="{ 'is-open': isCollapsedToolActive('shop') }" :shops="shops" popup />
        <UiIconControl slot="reference" :title="$t('商铺选择')" icon="ui-icon-glyph terminal-nav-icon iconfont icon-a-shanghu_choose2x1" :active="isCollapsedToolActive('shop')" :flashing="isCollapsedToolFlashing('shop')" toggle @mousedown.stop @click.stop="toggleCollapsedTool('shop')" />
      </UiPopover>
      <UiPopover
        ref="collapsedFleetPopover"
        :popper-options="collapsedPopoverOptions"
        placement="left-start"
        width="276"
        trigger="manual"
        :value="isCollapsedToolActive('fleet')"
        transition="ground-station-popover"
        popper-class="ground-station-collapsed-panel"
        @click.native.stop
        @after-enter="scheduleCollapsedPopoverStack"
      >
        <GroundStationPlaneSelector
          class="collapsed-popover-content"
          :class="{ 'is-open': isCollapsedToolActive('fleet') }"
          :planes="planes"
          :selected-plane-id="selectedPlaneId"
          :delivering-plane-ids="deliveringPlaneIds"
          popup
          @select="selectPlane"
        />
        <UiIconControl slot="reference" :title="$t('飞机选择')" icon="ui-icon-glyph terminal-nav-icon iconfont icon-wurenji" :active="isCollapsedToolActive('fleet')" :flashing="isCollapsedToolFlashing('fleet')" toggle @mousedown.stop @click.stop="toggleCollapsedTool('fleet')" />
      </UiPopover>
      <UiPopover
        v-if="selectedPlane"
        ref="collapsedMissionPopover"
        :popper-options="collapsedPopoverOptions"
        placement="left-start"
        width="276"
        trigger="manual"
        :value="isCollapsedToolActive('mission')"
        :visible-arrow="!isCollapsedToolActive('fleet')"
        transition="ground-station-popover"
        popper-class="ground-station-collapsed-panel"
        @click.native.stop
        @after-enter="scheduleCollapsedPopoverStack"
      >
        <GroundStationMissionPanel class="collapsed-panel-component collapsed-popover-content" :class="{ 'is-open': isCollapsedToolActive('mission') }" :plane="selectedPlane" @focus-route="$emit('focus-route', $event)" />
        <UiIconControl slot="reference" class="collapsed-mission-control" :title="$t('当前任务')" icon="ui-icon-glyph terminal-nav-icon iconfont icon-songcanfuwu" :active="isCollapsedToolActive('mission')" :flashing="isCollapsedToolFlashing('mission')" toggle @mousedown.stop @click.stop="toggleCollapsedTool('mission')">
          <UiCountBadge class="collapsed-mission-badge" :count="pendingMissionCount" />
        </UiIconControl>
      </UiPopover>
      <UiPopover
        v-if="selectedPlane"
        ref="collapsedFlightPopover"
        :popper-options="collapsedPopoverOptions"
        placement="left-start"
        width="320"
        trigger="manual"
        :value="isCollapsedToolActive('flight')"
        :visible-arrow="!isCollapsedToolActive('fleet')"
        transition="ground-station-popover"
        popper-class="ground-station-collapsed-panel"
        @click.native.stop
        @after-enter="scheduleCollapsedPopoverStack"
      >
        <div class="collapsed-popover-content" :class="{ 'is-open': isCollapsedToolActive('flight') }">
          <div class="collapsed-panel-heading collapsed-panel-heading-flight gs-section-heading has-icon"><span><i class="iconfont icon-youxishoubing" aria-hidden="true"></i>{{ $t("飞机控制") }}</span></div>
          <GroundStationQuickControlPanel class="collapsed-panel-component" :plane="selectedPlane" :show-tabs="false" />
        </div>
        <UiIconControl slot="reference" :title="$t('飞机控制')" icon="ui-icon-glyph terminal-nav-icon iconfont icon-youxishoubing" :active="isCollapsedToolActive('flight')" :flashing="isCollapsedToolFlashing('flight')" toggle @mousedown.stop @click.stop="toggleCollapsedTool('flight')" />
      </UiPopover>
      <UiPopover
        v-if="selectedPlane && hasSelectedPlanePeripheralModule"
        ref="collapsedPeripheralPopover"
        :popper-options="collapsedPopoverOptions"
        placement="left-start"
        width="320"
        trigger="manual"
        :value="isCollapsedToolActive('peripheral')"
        :visible-arrow="!isCollapsedToolActive('fleet')"
        transition="ground-station-popover"
        popper-class="ground-station-collapsed-panel"
        @click.native.stop
        @after-enter="scheduleCollapsedPopoverStack"
      >
        <div class="collapsed-popover-content" :class="{ 'is-open': isCollapsedToolActive('peripheral') }">
          <div class="collapsed-panel-heading gs-section-heading has-icon"><span><i class="iconfont icon-linghuokuozhan" aria-hidden="true"></i>{{ $t("外设控制") }}</span></div>
          <GroundStationPeripheralControlPanel class="collapsed-panel-component" :plane="selectedPlane" />
        </div>
        <UiIconControl slot="reference" :title="$t('外设控制')" icon="ui-icon-glyph terminal-nav-icon iconfont icon-linghuokuozhan" :active="isCollapsedToolActive('peripheral')" :flashing="isCollapsedToolFlashing('peripheral')" toggle @mousedown.stop @click.stop="toggleCollapsedTool('peripheral')" />
      </UiPopover>
    </div>
    <div v-else-if="!collapsed" class="fleet-panel-content">
      <!-- God 账号可按商铺筛选机队 -->
      <GroundStationShopSelector v-if="isGod && showShopSelector" v-model="selectedShopId" :shops="shops" />
      <GroundStationPlaneSelector
        :planes="planes"
        :selected-plane-id="selectedPlaneId"
        :delivering-plane-ids="deliveringPlaneIds"
        @select="selectPlane"
      />
      <transition name="panel-deal">
        <!-- 当前任务、飞行控制和外设控制统一由操作面板切换。 -->
        <GroundStationOperationPanel ref="operationPanel" v-if="selectedPlane && showOperations" :plane="selectedPlane" @focus-route="$emit('focus-route', $event)" />
      </transition>
    </div>
  </aside>
</template>

<script>
import GroundStationMissionPanel from '@/components/ground-station/GroundStationMissionPanel'
import GroundStationQuickControlPanel from '@/components/ground-station/GroundStationQuickControlPanel'
import GroundStationPeripheralControlPanel from '@/components/ground-station/GroundStationPeripheralControlPanel'
import GroundStationOperationPanel from '@/components/ground-station/GroundStationOperationPanel'
import GroundStationShopSelector from '@/components/ground-station/GroundStationShopSelector'
import GroundStationPlaneSelector from '@/components/ground-station/GroundStationPlaneSelector'
import { speakText } from '@/utils/index'
import { hasPeripheralModule as planeHasPeripheralModule } from '@/utils/planeModules'
import { getAssignableOrdersForPlane } from '@/utils/operationalStatus'
import { resolveGroundStationPopoverLayout } from '@/utils/groundStationPopoverLayout'

const PERSISTED_COLLAPSED_TOOLS = ['mission', 'flight', 'peripheral']
const DEFAULT_FLEET_OPEN_DELAY = 360
const COLLAPSED_POPOVER_REFS = {
  shop: 'collapsedShopPopover',
  fleet: 'collapsedFleetPopover',
  mission: 'collapsedMissionPopover',
  flight: 'collapsedFlightPopover',
  peripheral: 'collapsedPeripheralPopover'
}
const COLLAPSED_TOOL_VOICE_LABELS = {
  shop: '商铺选择',
  fleet: '飞机选择',
  mission: '当前任务',
  flight: '飞机控制',
  peripheral: '外设控制'
}

export default {
  name: 'GroundStationFleetPanel',
  components: {
    GroundStationMissionPanel,
    GroundStationQuickControlPanel,
    GroundStationPeripheralControlPanel,
    GroundStationOperationPanel,
    GroundStationShopSelector,
    GroundStationPlaneSelector
  },
  data () {
    return {
      activeCollapsedTools: [],
      defaultFleetOpenTimer: null,
      collapsedPopoverLayoutFrame: null,
      collapsedPopoverLayoutRequestId: 0,
      collapsedContentResizeObserver: null,
      observedCollapsedContents: [],
      observedCollapsedPopovers: [],
      flashingCollapsedTool: '',
      collapsedToolFlashTimer: null
    }
  },
  props: {
    planes: { type: Array, default: () => [] },
    shops: { type: Array, default: () => [] },
    isGod: { type: Boolean, default: false },
    showShopSelector: { type: Boolean, default: true },
    selectedPlaneId: { type: [String, Number], default: '' },
    deliveringPlaneIds: { type: Array, default: () => [] },
    collapsed: { type: Boolean, default: false },
    floating: { type: Boolean, default: false },
    showOperations: { type: Boolean, default: true },
    bottomLimit: { type: Number, default: null },
    suppressCollapsedPopovers: { type: Boolean, default: false }
  },
  computed: {
    collapsedPopoverOptions () {
      return { gpuAcceleration: false, onUpdate: this.updateCollapsedPopoverStack }
    },
    selectedShopId: {
      get () { return this.isGod ? this.$store.getters['app/getOverviewFleetShopId'] : '' },
      set (shopId) { this.$store.commit('app/setOverviewFleetShopId', shopId) }
    },
    selectedPlane () { return this.planes.find(item => String(item.id) === String(this.selectedPlaneId)) || null },
    hasSelectedPlanePeripheralModule () { return planeHasPeripheralModule(this.selectedPlane) },
    pendingMissionCount () {
      return getAssignableOrdersForPlane(this.$store.state.paidOrderList, this.selectedPlane).length
    }
  },
  watch: {
    bottomLimit () {
      // 底部状态操作框出现时立即让位，不再等待弹层入场的两帧定位。
      this.$nextTick(this.updateCollapsedPopoverStack)
    },
    activeCollapsedTools () {
      this.scheduleCollapsedPopoverStack()
    },
    collapsed: {
      immediate: true,
      handler (value) {
        if (this.defaultFleetOpenTimer) clearTimeout(this.defaultFleetOpenTimer)
        this.defaultFleetOpenTimer = null
        this.activeCollapsedTools = []
        if (!value || this.suppressCollapsedPopovers) return

        // 等待侧栏宽度动画结束，再按稳定后的按钮位置创建弹窗。
        this.defaultFleetOpenTimer = setTimeout(() => {
          this.defaultFleetOpenTimer = null
          if (!this.collapsed || this.suppressCollapsedPopovers || this.activeCollapsedTools.length) return

          const savedTool = this.selectedPlane ? this.getSavedCollapsedTool() : ''
          this.activeCollapsedTools = savedTool ? ['fleet', savedTool] : ['fleet']
        }, DEFAULT_FLEET_OPEN_DELAY)
      }
    },
    suppressCollapsedPopovers (value) {
      if (value) this.closeCollapsedTools()
    },
    selectedPlane (plane) {
      if (!plane) {
        this.activeCollapsedTools = this.activeCollapsedTools.filter(tool => !PERSISTED_COLLAPSED_TOOLS.includes(tool))
      } else if (this.collapsed) {
        if (!planeHasPeripheralModule(plane)) {
          this.activeCollapsedTools = this.activeCollapsedTools.filter(tool => tool !== 'peripheral')
        }
        this.$nextTick(this.restoreSavedCollapsedTool)
      }
      this.scheduleCollapsedPopoverStack()
    },
    isGod (value) {
      if (!value) this.activeCollapsedTools = this.activeCollapsedTools.filter(tool => tool !== 'shop')
    }
  },
  mounted () {
    window.addEventListener('resize', this.scheduleCollapsedPopoverStack)
    if (typeof ResizeObserver !== 'undefined') {
      this.collapsedContentResizeObserver = new ResizeObserver(this.updateCollapsedPopoverStack)
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.scheduleCollapsedPopoverStack)
    if (this.collapsedContentResizeObserver) this.collapsedContentResizeObserver.disconnect()
    this.clearCollapsedPopoverScrollListeners()
    if (this.defaultFleetOpenTimer) clearTimeout(this.defaultFleetOpenTimer)
    clearTimeout(this.collapsedToolFlashTimer)
    this.cancelCollapsedPopoverLayout()
  },
  methods: {
    getCollapsedToolSnapshot () {
      return [...this.activeCollapsedTools]
    },
    getOperationPanelSnapshot () {
      return this.$refs.operationPanel ? this.$refs.operationPanel.activePanel : ''
    },
    closeCollapsedTools () {
      if (this.defaultFleetOpenTimer) clearTimeout(this.defaultFleetOpenTimer)
      this.defaultFleetOpenTimer = null
      this.cancelCollapsedPopoverLayout()
      if (this.collapsedContentResizeObserver) this.collapsedContentResizeObserver.disconnect()
      this.observedCollapsedContents = []
      this.clearCollapsedPopoverScrollListeners()
      this.activeCollapsedTools = []
      this.resetCollapsedPopoverOffsets()
    },
    restoreCollapsedToolSnapshot (tools) {
      if (!this.collapsed || this.suppressCollapsedPopovers) return
      const availableTools = (Array.isArray(tools) ? tools : []).filter(tool => (
        Object.prototype.hasOwnProperty.call(COLLAPSED_POPOVER_REFS, tool) &&
        (tool !== 'shop' || this.isGod) &&
        (tool !== 'peripheral' || this.hasSelectedPlanePeripheralModule) &&
        (!['mission', 'flight', 'peripheral'].includes(tool) || this.selectedPlane)
      ))
      this.activeCollapsedTools = [...new Set(availableTools)]
      this.scheduleCollapsedPopoverStack()
    },
    restoreOperationPanelSnapshot (panel) {
      this.$nextTick(() => {
        const operationPanel = this.$refs.operationPanel
        if (operationPanel && typeof operationPanel.restorePanel === 'function') {
          operationPanel.restorePanel(panel)
        }
      })
    },
    selectPlane (planeId) { this.$emit('select', planeId) },
    isCollapsedToolActive (tool) {
      return this.activeCollapsedTools.includes(tool)
    },
    isCollapsedToolFlashing (tool) {
      return this.flashingCollapsedTool === tool
    },
    flashCollapsedTool (tool) {
      clearTimeout(this.collapsedToolFlashTimer)
      this.flashingCollapsedTool = ''
      this.$nextTick(() => {
        this.flashingCollapsedTool = tool
        this.collapsedToolFlashTimer = setTimeout(() => {
          this.flashingCollapsedTool = ''
          this.collapsedToolFlashTimer = null
        }, 660)
      })
    },
    isPersistedCollapsedTool (tool) {
      return PERSISTED_COLLAPSED_TOOLS.includes(tool)
    },
    getSavedCollapsedTool () {
      const isPanelVisible = this.$store.getters['app/getOverviewCollapsedPanelVisible']
      return PERSISTED_COLLAPSED_TOOLS.find(tool =>
        isPanelVisible(tool) &&
        (tool !== 'peripheral' || this.hasSelectedPlanePeripheralModule)
      ) || ''
    },
    persistCollapsedToolVisibility (tool, visible) {
      if (!this.isPersistedCollapsedTool(tool)) return
      this.$store.commit('app/setOverviewCollapsedPanelVisibility', { key: tool, visible })
    },
    announceCollapsedTool (tool) {
      const label = COLLAPSED_TOOL_VOICE_LABELS[tool]
      if (!label) return
      try {
        speakText(label)
      } catch (error) {
        console.warn('[GroundStationFleetPanel] 终端语音播报失败', error)
      }
    },
    restoreSavedCollapsedTool () {
      if (!this.collapsed || !this.selectedPlane) return

      const savedTool = this.getSavedCollapsedTool()
      if (!savedTool || this.isCollapsedToolActive(savedTool)) return

      const persistentTools = this.activeCollapsedTools.filter(tool => tool === 'fleet')
      this.activeCollapsedTools = [...persistentTools, savedTool]
    },
    toggleCollapsedTool (tool) {
      if (this.suppressCollapsedPopovers) return
      this.flashCollapsedTool(tool)
      if (this.isCollapsedToolActive(tool)) {
        if (tool === 'fleet') this.resetCollapsedPopoverOffsets()
        this.persistCollapsedToolVisibility(tool, false)
        this.activeCollapsedTools = this.activeCollapsedTools.filter(item => item !== tool)
        return
      }

      if (tool === 'fleet') {
        this.activeCollapsedTools = [...this.activeCollapsedTools, tool]
        this.announceCollapsedTool(tool)
        return
      }

      const activeSecondary = this.getActiveSecondaryTool()
      if (activeSecondary && this.isPersistedCollapsedTool(activeSecondary)) {
        this.persistCollapsedToolVisibility(activeSecondary, false)
      }
      const persistentTools = this.activeCollapsedTools.filter(item => item === 'fleet')
      this.activeCollapsedTools = [...persistentTools, tool]
      this.persistCollapsedToolVisibility(tool, true)
      this.announceCollapsedTool(tool)
    },
    scheduleCollapsedPopoverStack () {
      const requestId = ++this.collapsedPopoverLayoutRequestId
      if (this.collapsedPopoverLayoutFrame !== null) cancelAnimationFrame(this.collapsedPopoverLayoutFrame)
      this.$nextTick(() => this.$nextTick(() => {
        if (!this.isCollapsedPopoverLayoutCurrent(requestId)) return
        this.collapsedPopoverLayoutFrame = requestAnimationFrame(() => {
          this.collapsedPopoverLayoutFrame = null
          if (!this.isCollapsedPopoverLayoutCurrent(requestId)) return
          this.refreshCollapsedPopoverPositions()
          this.collapsedPopoverLayoutFrame = requestAnimationFrame(() => {
            this.collapsedPopoverLayoutFrame = null
            if (!this.isCollapsedPopoverLayoutCurrent(requestId)) return
            this.updateCollapsedPopoverStack()
          })
        })
      }))
    },
    cancelCollapsedPopoverLayout () {
      this.collapsedPopoverLayoutRequestId += 1
      if (this.collapsedPopoverLayoutFrame !== null) cancelAnimationFrame(this.collapsedPopoverLayoutFrame)
      this.collapsedPopoverLayoutFrame = null
    },
    isCollapsedPopoverLayoutCurrent (requestId) {
      return requestId === this.collapsedPopoverLayoutRequestId &&
        this.collapsed &&
        !this.suppressCollapsedPopovers &&
        this.$el &&
        this.$el.isConnected
    },
    getCollapsedPopover (tool) {
      return this.$refs[COLLAPSED_POPOVER_REFS[tool]] || null
    },
    refreshCollapsedPopoverPositions () {
      Object.keys(COLLAPSED_POPOVER_REFS).forEach(tool => {
        if (!this.isCollapsedToolActive(tool)) return
        const popover = this.getCollapsedPopover(tool)
        if (popover && typeof popover.updatePopper === 'function') popover.updatePopper()
      })
    },
    getCollapsedPopoverElement (tool) {
      const popover = this.getCollapsedPopover(tool)
      return popover && popover.$refs ? popover.$refs.popper : null
    },
    getCollapsedPopoverReference (tool) {
      const popover = this.getCollapsedPopover(tool)
      return popover ? popover.referenceElm : null
    },
    getActiveSecondaryTool () {
      return ['shop', 'mission', 'flight', 'peripheral'].find(tool => this.isCollapsedToolActive(tool)) || ''
    },
    measureCollapsedPopoverHeight (tool) {
      const element = this.getCollapsedPopoverElement(tool)
      if (!element) return 0
      if (element.offsetHeight) return element.offsetHeight

      const previous = {
        display: element.style.display,
        visibility: element.style.visibility,
        position: element.style.position,
        left: element.style.left,
        top: element.style.top,
        transform: element.style.transform
      }
      element.style.display = 'block'
      element.style.visibility = 'hidden'
      element.style.position = 'fixed'
      element.style.left = '-10000px'
      element.style.top = '0'
      element.style.transform = 'none'
      const height = element.offsetHeight
      Object.assign(element.style, previous)
      return height
    },
    getCollapsedPopoverViewport () {
      const panelRect = this.$el.getBoundingClientRect()
      const toolsElement = this.$el.querySelector('.collapsed-fleet-tools')
      const contentTop = toolsElement ? toolsElement.getBoundingClientRect().top : panelRect.top
      return { viewportTop: contentTop + 10, viewportBottom: Math.min(window.innerHeight, panelRect.bottom) - 10 }
    },
    placeCollapsedPopover (tool, targetTop, stackFromTop = false, bottomLimit = this.bottomLimit) {
      const element = this.getCollapsedPopoverElement(tool)
      const reference = this.getCollapsedPopoverReference(tool)
      if (!element || !reference) return 0

      element.style.marginTop = ''
      element.style.height = ''
      element.style.maxHeight = ''
      element.style.overflowX = ''
      element.style.overflowY = ''

      const { viewportTop, viewportBottom } = this.getCollapsedPopoverViewport()
      const naturalHeight = this.measureCollapsedPopoverHeight(tool)
      const { top: resolvedTop, maxHeight: availableHeight, height } = resolveGroundStationPopoverLayout({
        targetTop,
        naturalHeight,
        viewportTop,
        viewportBottom,
        bottomLimit,
        stackFromTop
      })
      // 内容暂时较短也保留上限，后续展开云台等控件不能突破底部边界。
      element.style.maxHeight = `${availableHeight}px`
      element.style.overflowX = 'hidden'
      element.style.overflowY = 'auto'

      // Popper 可能已把高面板向上推，不能再以按钮位置叠加 marginTop。
      element.style.top = `${resolvedTop + window.pageYOffset}px`
      this.updateCollapsedPopoverScrollHint(element)
      return height
    },
    getCollapsedFleetTargetTop () {
      const fleetReference = this.getCollapsedPopoverReference('fleet')
      if (!fleetReference) return 0

      const fleetTop = fleetReference.getBoundingClientRect().top
      if (!this.isGod) return fleetTop

      const shopReference = this.getCollapsedPopoverReference('shop')
      if (!shopReference) return fleetTop

      const shopTop = shopReference.getBoundingClientRect().top
      if (!this.isCollapsedToolActive('shop')) return shopTop

      return shopTop + this.measureCollapsedPopoverHeight('shop') + 10
    },
    updateCollapsedFleetOffset () {
      const targetTop = this.getCollapsedFleetTargetTop()
      this.placeCollapsedPopover('fleet', targetTop, true)
    },
    prepareCollapsedPopoverStack (tool) {
      const firstTool = tool === 'shop' ? 'shop' : 'fleet'
      const secondTool = tool === 'shop' ? 'fleet' : tool
      const firstReference = this.getCollapsedPopoverReference(firstTool)
      if (!firstReference || !this.getCollapsedPopoverElement(secondTool)) return

      const targetTop = tool === 'shop' ? firstReference.getBoundingClientRect().top : this.getCollapsedFleetTargetTop()
      const { top, maxHeight } = resolveGroundStationPopoverLayout({
        ...this.getCollapsedPopoverViewport(),
        targetTop,
        naturalHeight: 0,
        bottomLimit: this.bottomLimit,
        stackFromTop: true
      })
      // 矮屏也给第二面板保留一组标题/按钮的滚动空间，不能被机队吃完。
      const gap = Math.min(10, maxHeight)
      const reservedHeight = Math.min(96, Math.max(0, (maxHeight - gap) / 2))
      const firstHeight = this.placeCollapsedPopover(firstTool, top, true, top + maxHeight - gap - reservedHeight)
      this.placeCollapsedPopover(secondTool, top + firstHeight + gap, true)
    },
    resetCollapsedPopoverOffsets () {
      ['fleet', 'shop', 'mission', 'flight', 'peripheral'].forEach(tool => {
        const element = this.getCollapsedPopoverElement(tool)
        if (element) {
          element.style.marginTop = ''
          element.style.height = ''
          element.style.maxHeight = ''
          element.style.overflowX = ''
          element.style.overflowY = ''
          element.classList.remove('has-scroll-above', 'has-scroll-below')
        }
      })
    },
    updateCollapsedPopoverStack () {
      if (this._isBeingDestroyed || this._isDestroyed || !this.collapsed || this.suppressCollapsedPopovers) return
      this.observeCollapsedPopoverContents()
      this.observeCollapsedPopoverScroll()
      const secondaryTools = ['shop', 'mission', 'flight', 'peripheral']
      if (!this.isCollapsedToolActive('fleet')) {
        this.resetCollapsedPopoverOffsets()
        secondaryTools.forEach(tool => {
          if (!this.isCollapsedToolActive(tool)) return
          const reference = this.getCollapsedPopoverReference(tool)
          if (reference) this.placeCollapsedPopover(tool, reference.getBoundingClientRect().top, false)
        })
        return
      }
      const activeSecondary = secondaryTools.find(tool => this.isCollapsedToolActive(tool))
      if (activeSecondary) this.prepareCollapsedPopoverStack(activeSecondary)
      else this.updateCollapsedFleetOffset()
    },
    updateCollapsedPopoverScrollHint (element) {
      const scrollable = element.scrollHeight - element.clientHeight > 1
      element.classList.toggle('has-scroll-above', scrollable && element.scrollTop > 1)
      element.classList.toggle('has-scroll-below', scrollable && element.scrollTop + element.clientHeight < element.scrollHeight - 1)
    },
    onCollapsedPopoverScroll (event) {
      this.updateCollapsedPopoverScrollHint(event.currentTarget)
    },
    clearCollapsedPopoverScrollListeners () {
      this.observedCollapsedPopovers.forEach(element => {
        element.removeEventListener('scroll', this.onCollapsedPopoverScroll)
        element.classList.remove('has-scroll-above', 'has-scroll-below')
      })
      this.observedCollapsedPopovers = []
    },
    observeCollapsedPopoverScroll () {
      const elements = Object.keys(COLLAPSED_POPOVER_REFS)
        .filter(tool => this.isCollapsedToolActive(tool))
        .map(tool => this.getCollapsedPopoverElement(tool))
        .filter(Boolean)
      this.observedCollapsedPopovers.forEach(element => {
        if (!elements.includes(element)) {
          element.removeEventListener('scroll', this.onCollapsedPopoverScroll)
          element.classList.remove('has-scroll-above', 'has-scroll-below')
        }
      })
      elements.forEach(element => {
        if (!this.observedCollapsedPopovers.includes(element)) {
          element.addEventListener('scroll', this.onCollapsedPopoverScroll, { passive: true })
        }
      })
      this.observedCollapsedPopovers = elements
    },
    observeCollapsedPopoverContents () {
      if (!this.collapsedContentResizeObserver) return
      const contents = Object.keys(COLLAPSED_POPOVER_REFS)
        .filter(tool => this.isCollapsedToolActive(tool))
        .map(tool => this.getCollapsedPopoverElement(tool)?.firstElementChild)
        .filter(Boolean)
      this.observedCollapsedContents.forEach(element => {
        if (!contents.includes(element)) this.collapsedContentResizeObserver.unobserve(element)
      })
      contents.forEach(element => {
        if (!this.observedCollapsedContents.includes(element)) this.collapsedContentResizeObserver.observe(element)
      })
      this.observedCollapsedContents = contents
    }
  }
}
</script>

<style lang="scss" scoped>
.fleet-panel {
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  color: var(--ui-text-primary);
  border-left: 1px solid var(--ui-border-color-subtle);
  background: var(--ui-bg-panel);
  scrollbar-width: thin;
  scrollbar-color: var(--ui-border-color) transparent;
}

.fleet-panel,
.fleet-panel * {
  box-sizing: border-box;
}

.fleet-panel-content {
  width: 100%;
  min-width: 0;
  min-height: 0;
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
}

/* 从后台管理切回展开的地面站时，主要面板按视觉层级依次发牌入场。 */
.fleet-panel-content > :not(.operation-panel) {
  animation: expanded-panel-deal-in .36s cubic-bezier(.2, .76, .24, 1) both;
}

.fleet-panel-content > :nth-child(1) { animation-delay: 40ms; }
.fleet-panel-content > :nth-child(2) { animation-delay: 105ms; }

@keyframes expanded-panel-deal-in {
  from {
    opacity: 0;
    transform: translate3d(22px, -9px, 0) rotate(1.5deg) scale(.97);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0) rotate(0) scale(1);
  }
}

.selected-plane-panels {
  width: 100%;
  min-width: 0;
}

.fleet-panel.is-floating {
  border-left-color: transparent;
  background: transparent;
  pointer-events: none;
}

.is-floating .collapsed-fleet-tools :deep(.terminal-icon-control),
.is-floating .fleet-panel-content {
  pointer-events: auto;
}

.panel-deal-enter-active {
  animation: selected-panel-deal-in .46s cubic-bezier(.2, .72, .24, 1) both;
}

.panel-deal-enter-active:nth-child(2) {
  animation-delay: 140ms;
}

.panel-deal-leave-active {
  animation: selected-panel-deal-out .16s ease-in both;
}

@keyframes selected-panel-deal-in {
  from { opacity: 0; transform: translate3d(24px, -12px, 0) rotate(1.8deg) scale(.97); }
  to { opacity: 1; transform: translate3d(0, 0, 0) rotate(0) scale(1); }
}

@keyframes selected-panel-deal-out {
  to { opacity: 0; transform: translate3d(-8px, -4px, 0) scale(.98); }
}

.collapsed-fleet-tools {
  display: grid;
  justify-items: center;
  gap: var(--terminal-collapsed-control-gap, 10px);
  padding: var(--terminal-collapsed-control-gap, 10px) 0;
}

/* 侧栏折叠后，导航按钮按顺序落位，形成轻量的发牌反馈。 */
.collapsed-fleet-tools > * {
  animation: collapsed-tool-deal-in .2s ease both;
}

.collapsed-fleet-tools > :nth-child(1) { animation-delay: 35ms; }
.collapsed-fleet-tools > :nth-child(2) { animation-delay: 80ms; }
.collapsed-fleet-tools > :nth-child(3) { animation-delay: 125ms; }
.collapsed-fleet-tools > :nth-child(4) { animation-delay: 170ms; }
.collapsed-fleet-tools > :nth-child(5) { animation-delay: 215ms; }

@keyframes collapsed-tool-deal-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

.collapsed-fleet-tools button {
  width: var(--terminal-collapsed-control-size, 40px);
  height: var(--terminal-collapsed-control-size, 40px);
}

.collapsed-mission-control {
  position: relative;
  overflow: visible;
}

::v-deep .collapsed-mission-badge {
  position: absolute;
  z-index: 3;
  top: -4px;
  right: -4px;
}

.collapsed-fleet-tools i {
  margin: 0;
}
</style>

<style lang="scss">
.ground-station-collapsed-shop-popover.el-popover,
.ground-station-collapsed-panel.el-popover {
  margin-right: var(--ui-space-sm);
  margin-left: 0;
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
  color: var(--ui-text-primary);
  border-color: var(--ui-border-color);
  border-radius: var(--ui-radius-large);
  background: var(--ui-bg-surface);
  box-shadow: var(--gs-shadow-floating);
  overscroll-behavior: contain;
}

.ground-station-collapsed-shop-popover .popper__arrow::after,
.ground-station-collapsed-panel .popper__arrow::after {
  border-left-color: var(--ui-bg-surface) !important;
}

/* 仅在对应方向还有内容时显示静态渐变，不占空间、不拦截触摸。 */
.ground-station-collapsed-panel.el-popover.has-scroll-above::before,
.ground-station-collapsed-panel.el-popover.has-scroll-below::after,
.ground-station-collapsed-shop-popover.el-popover.has-scroll-above::before,
.ground-station-collapsed-shop-popover.el-popover.has-scroll-below::after {
  content: '';
  display: block;
  position: sticky;
  z-index: 2;
  height: 15px;
  pointer-events: none;
}

.ground-station-collapsed-panel.el-popover.has-scroll-above::before,
.ground-station-collapsed-shop-popover.el-popover.has-scroll-above::before {
  top: 0;
  margin-bottom: -15px;
  background: linear-gradient(to bottom, var(--ui-bg-surface), transparent);
}

.ground-station-collapsed-panel.el-popover.has-scroll-below::after,
.ground-station-collapsed-shop-popover.el-popover.has-scroll-below::after {
  bottom: 0;
  margin-top: -15px;
  background: linear-gradient(to top, var(--ui-bg-surface), transparent);
}

.collapsed-panel-heading {
  min-height: 42px;
  display: flex;
  align-items: center;
  padding: 0 var(--ui-space-md);
  color: var(--ui-text-primary);
  font-size: var(--gs-font-heading, 12px);
  font-weight: var(--gs-weight-semibold, 600);
  line-height: 1;
  letter-spacing: var(--gs-letter-heading, .35px);
}

.collapsed-panel-heading-flight {
  border-bottom: 1px solid var(--ui-border-color-subtle);
}

.collapsed-panel-component {
  width: 100%;
  box-sizing: border-box;
}

.ground-station-popover-enter-active {
  transition: opacity .2s ease, box-shadow .2s ease;
}

.ground-station-popover-leave-active {
  transition: opacity .14s ease;
}

.ground-station-popover-enter,
.ground-station-popover-leave-to {
  opacity: 0;
  box-shadow: 0 3px 10px rgba(var(--ui-color-black-rgb), .2);
}

.collapsed-popover-content.is-open .panel-heading,
.collapsed-popover-content.is-open .collapsed-panel-heading,
.collapsed-popover-content.is-open .shop-select-wrap,
.collapsed-popover-content.is-open .fleet-selector,
.collapsed-popover-content.is-open .mission-title,
.collapsed-popover-content.is-open .mission-timeline,
.collapsed-popover-content.is-open .mission-order-select,
.collapsed-popover-content.is-open .mission-card > dl,
.collapsed-popover-content.is-open .mission-warnings,
.collapsed-popover-content.is-open .mission-actions,
.collapsed-popover-content.is-open .cargo-actions,
.collapsed-popover-content.is-open .control-button:not(.lock-swap-button),
.collapsed-popover-content.is-open .device-section,
.collapsed-popover-content.is-open .empty-device {
  animation: collapsed-content-deal-in .34s cubic-bezier(.18, .76, .24, 1) both;
}

.collapsed-popover-content.is-open .panel-heading,
.collapsed-popover-content.is-open .collapsed-panel-heading {
  animation-delay: 90ms;
}

.collapsed-popover-content.is-open .shop-select-wrap,
.collapsed-popover-content.is-open .fleet-selector,
.collapsed-popover-content.is-open .mission-title,
.collapsed-popover-content.is-open .control-button:nth-child(1),
.collapsed-popover-content.is-open .device-section:nth-child(1),
.collapsed-popover-content.is-open .empty-device {
  animation-delay: 155ms;
}

.collapsed-popover-content.is-open .mission-timeline,
.collapsed-popover-content.is-open .control-button:nth-child(2),
.collapsed-popover-content.is-open .device-section:nth-child(2) {
  animation-delay: 220ms;
}

.collapsed-popover-content.is-open .mission-order-select,
.collapsed-popover-content.is-open .mission-card > dl,
.collapsed-popover-content.is-open .control-button:nth-child(3),
.collapsed-popover-content.is-open .device-section:nth-child(3) {
  animation-delay: 285ms;
}

.collapsed-popover-content.is-open .mission-warnings,
.collapsed-popover-content.is-open .control-button:nth-child(4),
.collapsed-popover-content.is-open .device-section:nth-child(4) {
  animation-delay: 350ms;
}

.collapsed-popover-content.is-open .mission-actions,
.collapsed-popover-content.is-open .control-button:nth-child(5) {
  animation-delay: 415ms;
}

.collapsed-popover-content.is-open .cargo-actions,
.collapsed-popover-content.is-open .control-button:nth-child(6) {
  animation-delay: 480ms;
}

.collapsed-popover-content.is-open .control-button:nth-child(7) {
  animation-delay: 545ms;
}

@keyframes collapsed-content-deal-in {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style>
